import { Component, OnInit, TemplateRef, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ModalTemplateComponent } from 'app/shared/modal-template/modal-template.component';
import { ESE_ENUM, ESE_MAP_KEYS, ESE_TEMPLATE_MODALS, ESE_FRAMEWORK_KEYS } from 'app/shared/enums/ese.enum';
import { UtilsService } from 'app/shared/utils.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ESEService } from 'app/shared/ese.service';
import * as ExcelJS from 'exceljs';
import { ClientLambdaService } from 'app/shared/client-lambda.service';
import { CreateEseFromTemplateModalComponent } from '../create-ese-from-template-modal/create-ese-from-template-modal.component';
import { FileTypeEnum } from 'app/API.service';
import { EmergingSecurityEventTableComponent } from 'app/shared/emerging-security-event-table/emerging-security-event-table.component';
import { DomainFrameworkService } from 'app/shared/domain-framework.service';

@Component({
  selector: 'cygov-emerging-security-event-modal',
  templateUrl: './emerging-security-event-modal.component.html',
  styleUrls: ['./emerging-security-event-modal.component.scss'],
  standalone: false,
})
export class EmergingSecurityEventModalComponent implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private toaster: ToastrService,
    private eseService: ESEService,
    private clientLambdaService: ClientLambdaService
  ) {}

  // Inputs
  @Input() entity: any;
  @Input() isFromVendorListing: boolean = false;
  @Input() selectedVendors: any = [];
  @Input() currentUser: string = '';
  @Output() closeEvent = new EventEmitter<any>();

  // State variables
  headerItemsESE: any = [];
  initialQuestionObject: any;
  initialErrorObject: { [key: string]: boolean };
  keysObject: any;
  questions: any = [];
  validationErrors: { [rowIndex: number]: { [key: string]: boolean } } = {};
  closeModalInstance: any;
  isEditMode: boolean = false;
  entityId: string = '';
  isLoading: boolean = true;
  isDataValidated: boolean = false;
  selectedQuestion: any = [];
  failedRows: any = [];
  ESEModalEnum = ESE_TEMPLATE_MODALS;
  selectedVendorName: string = '';
  eventName: string = '';
  eseLambdaResponse = null;
  isProcessing: boolean = false;

  // Modal config for ESE acknowledgment
  ngbModalOptionsNewAcknowledgement: NgbModalOptions = {
    size: 'sm',
    windowClass: 'modal-template-cont confirmation-filter-popup-window ese-template-acknowledgement-modal-window',
    backdropClass:
      'modal-template-cont-backdrop risk-popup-backdrop-modal ese-template-acknowledgement-request-modal-backdrop',
    backdrop: 'static',
    centered: true,
  };
  ngbModalOptionsCretaeFromTemplate: NgbModalOptions = {
    size: 'sm',
    windowClass: 'modal-template-cont confirmation-filter-popup-window ese-template-questionnaire-uplaod-modal-window',
    backdropClass:
      'modal-template-cont-backdrop risk-popup-backdrop-modal ese-template-questionnaire-uplaod-modal-backdrop',
    backdrop: 'static',
    centered: true,
  };
  ngbModalOptionsESEModal: NgbModalOptions = {
    size: 'sm',
    windowClass: 'create-ese-from-template-modal-window',
    backdropClass: 'create-ese-from-template-modal-backdrop',
    backdrop: 'static',
  };
  @ViewChild('eseAcknowledgementHeader') eseacknowledgementHeader!: TemplateRef<any>;
  @ViewChild('eseAcknowledgementContent') eseAcknowledgementContent!: TemplateRef<any>;
  @ViewChild('eseCreateFromTemaplteAcknowledgementContent')
  eseCreateFromTemaplteAcknowledgementContent!: TemplateRef<any>;
  @ViewChild('eseAcknowledgementFooter') eseAcknowledgementFooter!: TemplateRef<any>;
  @ViewChild('emergingSecurityEventTable') emergingSecurityEventTable!: EmergingSecurityEventTableComponent;

  disableDelete: boolean = true;
  removeFields = [ESE_ENUM.TEMPLATE_FILE, 'originalIndex', 'isUploaderOpen', ESE_ENUM.TEMPLATE, 'isSelected'];
  templateFileName: string = '';

  ngOnInit() {
    this.initComponent();
    this.eseLambdaResponse = null;
  }

  notifySaveButtonClicked() {
    this.emergingSecurityEventTable.closeArtifactUploader();
  }

  /**
   * Initialize modal component by fetching data and setting initial state
   */
  private async initComponent(): Promise<void> {
    this.entityId = UtilsService.getRouteParam(this.route.root.snapshot, 'entityId');
    this.initialErrorObject = this.eseService.initialErrorObject;
    this.initialQuestionObject = this.eseService.initialQuestionObject;
    this.keysObject = this.eseService.keysObject;
    this.headerItemsESE = this.eseService.headerItemsESE;

    if (this.entity && this.entity.isESETemplate) {
      await this.eseService.initComponent(this.entityId, this.entity);
      this.questions = this.eseService.questions;
      this.questionDataValidation();
    }
    this.isLoading = false;
  }

  /**
   * Validate entire questions array and collect any row errors
   */
  questionDataValidation() {
    this.failedRows = [];
    this.validationErrors = {};

    this.questions.forEach((row, rowIndex) => {
      this.isDataValidated = true;
      this.validationErrors[rowIndex] = {};
      let count = 0;
      Object.keys(row).forEach(key => {
        const isNotValid = this.columnValidation(rowIndex, key);
        count = isNotValid && !this.removeFields.includes(key) ? count + 1 : count;
      });
      this.isDataValidated = count === 0 ? true : false;
      if (!this.isDataValidated) {
        this.failedRows.push(rowIndex);
      } else {
        const index = this.failedRows.findIndex(r => r === rowIndex);
        if (index >= 0) {
          this.failedRows.splice(index, 1);
        }
      }
    });
  }

  async sendEmailNotification(selectedVendors) {
    const vendors = selectedVendors.map(({ id, name, vendorDetails }) => ({
      id,
      name,
      primaryPoc: vendorDetails?.primaryPoc,
    }));
    const emailObject = {
      type: 'NOTIFY_VENDOR_EMERGING_SECURITY',
      vendors,
      rootId: this.entityId,
      eventName: this.eseService.eventName,
      domain: DomainFrameworkService.getDomain(),
    };
    await this.clientLambdaService.invokeLambda('sendNotification', emailObject);
  }

  /**
   * Validate a single cell in the questions table
   */
  columnValidation(rowIndex, key): boolean {
    const row = this.questions[rowIndex];
    const mandatoryComments = ['true', 'false'];
    const validValues = [null, undefined, ''];
    if (Object.keys(this.validationErrors).length) {
      let isEmpty = false;
      // Special case: check boolean values for specific fields
      if (key === ESE_ENUM.MANDATORY_ARTIFACTS || key === ESE_ENUM.MANDATORY_COMMENTS) {
        const value = row[key].toString();
        isEmpty = !mandatoryComments.includes(value.toLowerCase());
      } else {
        isEmpty = validValues.includes(row[key]);
      }
      this.validationErrors[rowIndex][key] = this.removeFields.includes(key) ? false : isEmpty;
      return isEmpty;
    }
  }

  /**
   * Close the modal
   */
  closeModal(isComplete = false): void {
    if (this.closeModalInstance) {
      this.closeModalInstance.close();
    }
    this.activeModal.close();
    this.closeEvent.emit({ isComplete, fileName: this.templateFileName, eseLambdaResponse: this.eseLambdaResponse });
  }

  /**
   * Open ESE acknowledgment modal with provided templates
   */
  openESEAcknowledgementModal(
    header: TemplateRef<any>,
    content: TemplateRef<any>,
    footer: TemplateRef<any>,
    modalType: any
  ) {
    const modalRef = this.modalService.open(
      ModalTemplateComponent,
      modalType === this.ESEModalEnum.ACKNOWLEDGEMENT
        ? this.ngbModalOptionsNewAcknowledgement
        : this.ngbModalOptionsCretaeFromTemplate
    );
    const compInstance = modalRef.componentInstance;

    this.closeModalInstance = modalRef;
    this.eventName = this.eseService?.eventName;
    this.selectedVendorName = this.eseService.formatVendors(this.selectedVendors);
    compInstance.customizeHeader = true;
    compInstance.headerContentRef = header;
    compInstance.contentRef = content;
    compInstance.footerContentRef = footer;
  }

  /**
   * Deep copy the updated questions into local state
   */
  updateLocalState(questions) {
    this.questions = JSON.parse(JSON.stringify(questions));
  }

  checkEventNameAndDueDate() {
    if (this.isFromVendorListing && this.questions.length && this.eseService.eventName && this.eseService.dueDate) {
      return true;
    } else if (!this.isFromVendorListing && this.questions.length) {
      return true;
    }
    return false;
  }

  /**
   * Add a new empty question row to the table
   */
  addQuestion() {
    this.removeIsSelected();
    this.isEditMode = true;

    const newRowIndex = this.questions.length;
    this.validationErrors[newRowIndex] = JSON.parse(JSON.stringify(this.initialErrorObject));

    const { questions } = this.eseService.addQuestion(this.questions);
    this.updateLocalState(questions);
  }

  /**
   * Handle inline question updates and validate
   */
  updateQuestion(event) {
    const { value, key, index } = event;
    this.questions[index][key] = value;
    // this.questionDataValidation();
  }

  removeArtifact(event) {
    const { questionIndex, fileIndex } = event;
    if (fileIndex !== null) {
      this.questions[questionIndex][this.keysObject.templateFile].splice(fileIndex, 1);
    } else {
      this.questions[questionIndex][this.keysObject.template] = '';
      this.questions[questionIndex][this.keysObject.templateFile] = [];
    }
  }

  /**
   * Upload questions to S3 after validation
   */
  async uploadTemplateToS3(): Promise<void> {
    try {
      this.questionDataValidation();

      if (!this.failedRows.length) {
        await this.eseService.uploadTemplateToS3(this.entityId, this.entity, this.questions);
        this.isEditMode = false;
      } else {
        this.toaster.info('Please validate data');
      }
    } catch (err) {
      console.log('Error in uploading file');
    }
  }

  /**
   * Remove isSelected property from all question rows
   */
  removeIsSelected() {
    this.questions = this.questions.map(({ isSelected, ...rest }) => rest);
  }
  removeUnnecessaryFields() {
    this.questions = this.questions.map(question => {
      const cleaned = { ...question };
      this.removeFields.forEach(field => {
        if (field !== ESE_ENUM.TEMPLATE) {
          delete cleaned[field];
        }
      });
      return cleaned;
    });
  }
  /**
   * Save data after validating it
   */
  onSave() {
    this.questionDataValidation();
    if (!this.failedRows.length) {
      this.isEditMode = false;
      this.eseService.onSave(this.questions);
    } else {
      this.toaster.info('Missing required fields. Please complete marked fields to save.');
    }
  }

  /**
   * Complete the process if data is valid
   */
  async onComplete(): Promise<void> {
    let toastInterval;
    this.toaster.info(
      this.isFromVendorListing ? 'ESE framework creation is in Progress.' : 'Template creation is in Progress.'
    );
    try {
      this.questionDataValidation();
      if (!this.failedRows.length) {
        toastInterval = setInterval(() => {
          this.toaster.info('Please wait it will take sometime to complete the process...', '', { timeOut: 1500 });
        }, 4000);
        this.isProcessing = true;
        await this.eseService.uploadArtifactTemplate(this.entityId, this.entity, this.questions);
        const formatedQuestionaire = this.transformObject();
        this.removeUnnecessaryFields();
        if (!this.isFromVendorListing) {
          this.templateFileName = `${FileTypeEnum.ESE_TEMP}${Date.now()}.xlsx`;
          await this.eseService.onComplete(this.entityId, this.entity, this.questions, this.templateFileName);
        }

        let assessmentIds = this.selectedVendors.map(v => v.activeAssessmentId).filter(id => !!id);
        assessmentIds = [...new Set(assessmentIds)];
        const selectedVendors = [...new Map(this.selectedVendors.map(item => [item.id, item])).values()];
        this.eseLambdaResponse = await this.createFrameworkFromTemplate(
          formatedQuestionaire,
          assessmentIds,
          selectedVendors
        );
        if (this.isFromVendorListing) {
          this.sendEmailNotification(selectedVendors);
        }
        this.openESEAcknowledgementModal(
          this.eseacknowledgementHeader,
          this.isFromVendorListing ? this.eseCreateFromTemaplteAcknowledgementContent : this.eseAcknowledgementContent,
          this.eseAcknowledgementFooter,
          this.ESEModalEnum.ACKNOWLEDGEMENT
        );
        this.isProcessing = false;
      } else {
        this.toaster.info('Missing required fields. Please complete marked fields to save.');
      }
    } catch (err) {
      console.log('Error while completing the process');
    } finally {
      // Stop repeating toast
      clearInterval(toastInterval);
    }
  }

  checkSelectedRow() {
    const selectedRow = this.questions.filter(q => q.isSelected);
    return selectedRow.length ? false : true;
  }
  /**
   * Mark a row as selected based on checkbox interaction
   */
  setSelectedRow(event) {
    this.questions[event.index].isSelected = event.isChecked;
    this.disableDelete = event.isChecked ? false : this.checkSelectedRow();
  }

  /**
   * Delete selected rows from the question list
   */
  onDelete() {
    const selectedRow = this.questions.filter(q => q.isSelected);

    if (!selectedRow.length) {
      this.toaster.info('Please select at least one row');
      return;
    }

    selectedRow.forEach(s => {
      const index = this.questions.findIndex(
        q => s[this.keysObject.questionNumber] === q[this.keysObject.questionNumber]
      );
      if (index >= 0) {
        this.questions.splice(index, 1);
      }
      /** Update the failedRows  */
      if (this.failedRows.length && this.failedRows.includes(index)) {
        const f_index = this.failedRows.findIndex(i => i === index);
        this.failedRows.splice(f_index, 1);
      }
    });
    this.removeIsSelected();
    // Reassign question numbers based on new order
    this.questions.forEach((q, index) => {
      q[this.keysObject.questionNumber] = index + 1;
    });
    this.eseService.onSave(this.questions);

    this.disableDelete = true;
  }

  /**
   * Download existing questions template
   */
  async onDownload(): Promise<void> {
    await this.eseService.onDownload();
  }

  /**
   * Enable edit mode for questions
   */
  enableEdit(edit) {
    this.isEditMode = edit;
    // if Edit mode close so restore the state.
    if (!this.isEditMode) {
      this.questions = JSON.parse(JSON.stringify(this.eseService.cachedQuestions));
      this.questionDataValidation();
    }
  }

  /**
   * Handle XLSX file upload, convert it to JSON, and add to questions list
   */

  onUpload(file: File) {
    // TODO: here open modal for warning
    const reader = new FileReader();

    reader.onload = async (e: ProgressEvent<FileReader>) => {
      const buffer = e.target?.result as ArrayBuffer;
      const workbook = new ExcelJS.Workbook();

      await workbook.xlsx.load(buffer);

      // Read second sheet (index 1)
      const worksheet = workbook.worksheets[1];
      if (!worksheet) {
        this.toaster.info('No second sheet found in the uploaded file');
        return;
      }

      // Convert worksheet to JSON manually
      const headerRow = worksheet.getRow(1);
      const headers = (Array.isArray(headerRow.values) ? headerRow.values : [])
        .slice(1)
        .map(h => (typeof h === 'string' ? h.trim() : ''));

      const jsonData: any[] = [];
      worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
        if (rowNumber === 1) {
          return;
        } // skip header
        const rowData: any = {};
        headers.forEach((header, colIndex) => {
          rowData[header] = row.getCell(colIndex + 1).value;
        });
        jsonData.push(rowData);
      });

      if (!jsonData.length) {
        this.toaster.info('Uploaded template is empty');
        return;
      }

      // Step 1: Remove empty header columns
      const allKeys = Object.keys(jsonData[0]).filter(key => key.trim() !== '');
      // Step2: Check all columns are in file

      const missingColumns = this.eseService.requiredColumns.filter(col => !allKeys.includes(col));
      if (missingColumns.length) {
        this.toaster.info(`The uploaded file is missing required column(s): ${missingColumns.join(', ')}`);
        return;
      }

      // Step 3: Remove columns that are empty (null) in all rows
      const nonEmptyColumns = allKeys.filter(key =>
        jsonData.some(row => this.eseService.requiredColumns.includes(key))
      );
      this.questions = [];
      // Step 4: Keep only non-empty columns
      const cleanedData = jsonData.map(row => {
        const cleanedRow: any = {};
        nonEmptyColumns.forEach(key => {
          cleanedRow[key] = row[key] != null ? row[key] : '';
        });
        return cleanedRow;
      });

      let newRowIndex = this.questions.length;
      this.enableEdit(true);

      cleanedData.forEach(d => {
        // Assign question number
        d[this.keysObject.questionNumber] = newRowIndex + 1;

        // Normalize mandatoryArtifacts
        const mandatoryArtifacts = d[this.keysObject.mandatoryArtifacts];
        d[this.keysObject.mandatoryArtifacts] =
          mandatoryArtifacts === true || mandatoryArtifacts === false
            ? this.eseService.capitalizeFirstLetter(mandatoryArtifacts.toString())
            : this.eseService.capitalizeFirstLetter(mandatoryArtifacts || '');

        // Normalize mandatoryComments
        const mandatoryComments = d[this.keysObject.mandatoryComments];
        d[this.keysObject.mandatoryComments] =
          mandatoryComments === true || mandatoryComments === false
            ? this.eseService.capitalizeFirstLetter(mandatoryComments.toString())
            : this.eseService.capitalizeFirstLetter(mandatoryComments || '');

        this.validationErrors[newRowIndex] = JSON.parse(JSON.stringify(this.initialErrorObject));
        this.questions.push(d);
        newRowIndex++;
      });

      this.questions = JSON.parse(JSON.stringify(this.questions));
      this.questionDataValidation();
    };

    reader.readAsArrayBuffer(file);
  }

  onUploadArtifact(event: { file: File; rowIndex: number }): void {
    const { file, rowIndex } = event;
    // Ensure the object exists
    const question = this.questions[rowIndex];
    if (question[ESE_ENUM.TEMPLATE] === '' || !question[ESE_ENUM.TEMPLATE]) {
      question[ESE_ENUM.TEMPLATE] = 'ESE_ARTIFACT';
    }

    if (Array.isArray(question[ESE_ENUM.TEMPLATE_FILE])) {
      question[ESE_ENUM.TEMPLATE_FILE].push(file);
    } else {
      question[ESE_ENUM.TEMPLATE_FILE] = [file];
    }
  }
  transformObject() {
    return this.questions.map(obj => {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        const newKey = ESE_MAP_KEYS[key] || key;
        if (key === ESE_ENUM.TEMPLATE && typeof value === 'string') {
          acc[newKey] = value.split('.')[0];
        } else {
          acc[newKey] = value;
        }
        return acc;
      }, {});
    });
  }

  async createFrameworkFromTemplate(formatedQuestionaire, assessmentIds, selctedVendors): Promise<void> {
    if (this.isFromVendorListing) {
      try {
        const vendorIds = selctedVendors.map(({ id }) => ({
          id,
        }));
        const payload = {
          assessmentIds,
          eventName: this.eseService.eventName,
          dueDate: this.eseService.dueDate,
          userId: this.currentUser,
          type: ESE_FRAMEWORK_KEYS.CUSTOM_RISK_FRAMEWORK,
          rootEntityId: this.entityId,
          vendorIds,
          questionaire: formatedQuestionaire,
        };
        const { Payload } = await this.clientLambdaService.invokeLambda(
          'createCustomFramework',
          payload,
          'RequestResponse'
        );

        const response = JSON.parse(Payload.transformToString());
        const body = JSON.parse(response.body).data;
        return body;
      } catch (err) {
        console.log('Error', err);
      }
    }
  }
  openCreatFromTemplateModal() {
    this.closeModal();
    const modalRef = this.modalService.open(CreateEseFromTemplateModalComponent, this.ngbModalOptionsESEModal);
    modalRef.componentInstance.entity = this.entity;
    modalRef.componentInstance.selectedVendors = this.selectedVendors;
    modalRef.componentInstance.currentUser = this.currentUser;
    modalRef.componentInstance.closeEvent = this.closeEvent;
  }
  get formattedFailedRows(): string {
    return this.eseService.formattedFailedRows(this.failedRows);
  }
}
